import { createFileRoute } from '@tanstack/react-router';
import { useIntl } from 'react-intl';
import { Head } from '@_/components';
import { BookmarksPage } from '#src/pages/SavedItemsPage/index.ts';

export const Route = createFileRoute('/{-$locale}/_auth/saved_/classes')({
  component: RouteComponent
});

function RouteComponent() {
  const intl = useIntl();

  return (
    <>
      <Head>
        <title>
          {intl.formatMessage({
            id: 'head.saved-classes',
            defaultMessage: 'Saved classes'
          })}
        </title>
      </Head>

      <BookmarksPage />
    </>
  );
}
